var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAnalyticsSvg({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "line-chart") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Navbar-new",
    transform: "translate(-31.000000, -348.000000)",
    fill: "#418AFE"
  }, /*#__PURE__*/React.createElement("g", {
    id: "line-chart",
    transform: "translate(31.000000, 348.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.08888889,1.11627907 C2.41976178,1.11627907 1.06666667,2.53230884 1.06666667,4.27906977 L1.06666667,11.7209302 C1.06666667,13.4676837 2.41976178,14.8837209 4.08888889,14.8837209 L11.2,14.8837209 C12.86912,14.8837209 14.2222222,13.4676837 14.2222222,11.7209302 L14.2222222,5.76744186 C14.2222222,5.45919256 14.4610133,5.20930233 14.7555556,5.20930233 C15.0500978,5.20930233 15.2888889,5.45919256 15.2888889,5.76744186 L15.2888889,11.7209302 C15.2888889,14.0841674 13.4582044,16 11.2,16 L4.08888889,16 C1.830656,16 0,14.0841674 0,11.7209302 L0,4.27906977 C0,1.91580279 1.830656,0 4.08888889,0 L10.4888889,0 C10.7834311,0 11.0222222,0.249890233 11.0222222,0.558139535 C11.0222222,0.866388837 10.7834311,1.11627907 10.4888889,1.11627907 L4.08888889,1.11627907 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0444444,1.11627907 C14.5353956,1.11627907 14.9333333,1.53275535 14.9333333,2.04651163 C14.9333333,2.56026791 14.5353956,2.97674419 14.0444444,2.97674419 C13.5534933,2.97674419 13.1555556,2.56026791 13.1555556,2.04651163 C13.1555556,1.53275535 13.5534933,1.11627907 14.0444444,1.11627907 Z M16,2.04651163 C16,0.916256744 15.12448,0 14.0444444,0 C12.9644089,0 12.0888889,0.916256744 12.0888889,2.04651163 C12.0888889,3.17676651 12.9644089,4.09302326 14.0444444,4.09302326 C15.12448,4.09302326 16,3.17676651 16,2.04651163 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.73767822,10.4665302 C3.51600356,10.2635907 3.49354667,9.91092093 3.68750933,9.67895814 L6.17639822,6.70221395 C6.36707556,6.47418047 6.69674667,6.44700279 6.91918222,6.64096744 L8.65258667,8.15263256 L10.7986489,5.58594233 C10.9925689,5.35395721 11.3294933,5.33045581 11.5512178,5.53344 C11.7728711,5.73642419 11.7953422,6.08903442 11.6013511,6.32101953 L9.11246222,9.29778605 C8.92181333,9.52580465 8.59214222,9.55296744 8.36970667,9.35903256 L6.63630222,7.84736744 L4.49025422,10.4140651 C4.29629156,10.6460279 3.95935289,10.6695442 3.73767822,10.4665302 L3.73767822,10.4665302 Z",
    id: "Path"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalyticsSvg);
export default __webpack_public_path__ + "static/media/Analytics_svg.0fbf4c6895724ece09f8c649c19b6f26.svg";
export { ForwardRef as ReactComponent };